import { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Select } from 'antd';
import { LockOutlined } from '@ant-design/icons';

import request from '../../api/request';
import FieldWrapper from '../../components/form/FieldWrapper';

const Wrapper = styled(FieldWrapper)`
  background: ${({ theme }) => theme.inputField.background};
  padding: 0.3rem;
  width: 400px;
  @media (max-width: 768px) {
    width: 330px;
  }
  box-shadow: ${({ theme }) => theme.div.boxShadow} !important;
  & > label {
    color: ${({ theme }) => theme.inputField.color};
    font-size: 0.8rem;
    padding: 0.2rem 0;
  }
`;

class SelectDashboardsField extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { options: [] };
    this.loadOptions = this.loadOptions.bind(this);
  }

  async loadOptions() {
    if (this.props.config.user_id != null && this.props.config.user_id !== this.props.user_id) {
      // external dashboard list
      try {
        const response = await request.get({
          url: '/dashboard/',
          query: { exclude_widgets: true },
          headers: { 'X-User-ID': this.props.config.user_id },
        });
        const options = response.results
          .map((dashboard) => ({
            value: dashboard.id,
            label: dashboard.name,
            restricted_access: dashboard.config?.restricted_access || false,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));

        this.setState(() => ({
          options: options,
        }));

        // eslint-disable-next-line no-empty
      } catch {}
    } else if (this.props.config.current_dashboard_id) {
      this.setState(() => ({
        options: this.props.dashboards
          .filter((dashboard) => dashboard.id !== this.props.config.current_dashboard_id)
          .map((dashboard) => ({
            value: dashboard.id,
            label: dashboard.name,
            is_external: dashboard.user_id !== this.props.user_id,
            external_user_name:
              dashboard.user_id !== this.props.user_id && dashboard.external_user_name
                ? dashboard.external_user_name
                : '',
          }))
          .sort((a, b) => a.label.localeCompare(b.label)),
      }));
    } else {
      if (this.props.config.user_id === null) {
        this.setState(() => ({
          options: [],
        }));
        return;
      }

      this.setState(() => ({
        options: this.props.dashboards
          .map((dashboard) => ({
            value: dashboard.id,
            label:
              dashboard.user_id !== this.props.user_id ? '[ext] ' + dashboard.name : dashboard.name,
            is_external: dashboard.user_id !== this.props.user_id,
            restricted_access: dashboard.config?.restricted_access || false,
          }))
          .sort((a, b) => a.label.localeCompare(b.label)),
      }));
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.config.user_id !== prevProps.config.user_id) {
      this.props.input.onChange(null);
      this.loadOptions();
    }
  }

  componentDidMount() {
    if (this.props.config.user_id) {
      this.loadOptions();
    }
  }

  render() {
    const { config, input, meta } = this.props;
    const use_multiple = config?.use_multiple || false;

    return (
      <Wrapper label={config.label} meta={meta}>
        <Select
          style={{ width: '100%' }}
          mode={use_multiple ? 'multiple' : null}
          // value={input.value}
          onChange={(value) => input.onChange(value)}
          onFocus={() => input.onFocus()}
          onBlur={() => input.onBlur()}
          placeholder={config.placeholder}
          options={this.state.options}
          allowClear
          showSearch
          filterOption={(inpt, option) => {
            const searchStr = inpt.toLowerCase();
            const isExternal = option.is_external === true;
            return (
              option.label.toLowerCase().includes(searchStr) ||
              (isExternal && 'ext'.includes(searchStr))
            );
          }}
          notFoundContent={config.label_not_found}
          optionRender={(option) => (
            <div>
              <div>
                {option.data.restricted_access === true && (
                  <LockOutlined style={{ marginRight: '5px' }} />
                )}
                {option.data.label}
              </div>
              {option.data.is_external === true && option.data.external_user_name && (
                <div>
                  <small style={{ color: '#ff725c' }}>{option.data.external_user_name}</small>
                </div>
              )}
            </div>
          )}
        />
      </Wrapper>
    );
  }
}

export default connect((state) => ({
  user_id: state.auth.user.id,
  dashboards: Object.values(state.dashboards),
}))(SelectDashboardsField);
